import { render, staticRenderFns } from "./StepFiveIcon.vue?vue&type=template&id=7b21171e"
import script from "./StepFiveIcon.vue?vue&type=script&lang=js"
export * from "./StepFiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports